import type { PropsWithChildren } from 'react';

import { useControllableState } from '@/hook';

import { VBaseCheckboxRadioGroupContext } from './context';
import type { VBaseCheckboxRadioGroupContextValue } from './type';

const VBaseCheckboxRadioGroupContextProvider = <
  M extends boolean,
  U = M extends true ? string[] : string,
>({
  children,
  defaultValue,
  value,
  onValueChange,
}: PropsWithChildren<VBaseCheckboxRadioGroupContextValue<M, U>> & {
  defaultValue?: U;
}) => {
  const [_value, _onValueChange] = useControllableState({
    prop: value,
    // FIXME: 초기값 설정. U가 string일 경우 빈 문자열로 설정해야함.
    defaultProp: defaultValue ?? ([] as U),
    onChange: onValueChange,
  });

  return (
    <VBaseCheckboxRadioGroupContext.Provider
      value={
        {
          value: _value,
          onValueChange: _onValueChange,
        } as VBaseCheckboxRadioGroupContextValue<M, U>
      }
    >
      {children}
    </VBaseCheckboxRadioGroupContext.Provider>
  );
};

export default VBaseCheckboxRadioGroupContextProvider;
